<div class="image-text">
    <img class="w-full" src="{{imageText.imageUrl}}" onerror="this.src='assets/images/image_fallback.png'" alt="{{imageText.name}}" />
    <ul>
        <li>
            <span class="bold gap">Serving Size </span>
            <span class="bold"> {{imageText.servingSize}} {{imageText.servingUnit}} 
                <span class="light">({{convertedServingUnit}} g)</span>
            </span>
        </li>
        <li>
            <span class="bold">Calories</span>
            <span class="bold">{{(nutritionInfo.totalCalories).toFixed(1)}} <span class="light">kcal</span></span>
        </li>
        <li>
            <span class="bold">Carbs</span>
            <span class="bold">{{(nutritionInfo.carbohydrates).toFixed(1)}} g 
                <span class="light">({{(nutritionInfo.totalCaloriesFromCarbs).toFixed(1)}} kcal)</span>
            </span>
        </li>
        <li>
            <span class="bold">Protein</span>
            <span class="bold">{{(nutritionInfo.protein).toFixed(1)}} g 
                <span class="light">({{(nutritionInfo.totalCaloriesFromProtein).toFixed(1)}} kcal)</span>
            </span>
        </li>
        <li>
            <span class="bold">Fats</span>
            <span class="bold">{{(nutritionInfo.fat).toFixed(1)}} g 
                <span class="light">({{(nutritionInfo.totalCaloriesFromFat).toFixed(1)}} kcal)</span>
            </span>
        </li>
    </ul>
</div>